import PhoneInput from "react-phone-input-2"
import styles from "./BasePhoneInput.module.css"
import cx from "classnames"
import "react-phone-input-2/lib/style.css"

type BasePhoneInputProps = {
    value: string
    onChange: (value: string) => void
    country?: string
    isError?: boolean
    disabled?: boolean
}

export function BasePhoneInput(props: BasePhoneInputProps) {
    const {value, onChange, country = "us", isError = false, disabled = false} = props

    const handleChange = (value: string) => {
        // Add + to the beginning of the value
        onChange(`+${value}`)
    }

    return (
        <PhoneInput
            country={country}
            value={value}
            onChange={handleChange}
            inputClass={cx(styles.phoneInputClass, {[styles.phoneInputError]: isError})}
            buttonClass={cx({[styles.phoneDropdownError]: isError})}
            disabled={disabled}
        />
    )
}
